 import { Link } from 'react-router-dom';
 import { UserX, Home, LogOut, Mail } from 'lucide-react';
 import { Button } from '@/components/ui/button';
 import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
 import { supabase } from '@/integrations/supabase/client';
 import { useNavigate } from 'react-router-dom';
 
 /**
  * Dealer Member Inactive Page
  * Shown when a sales team member's account has been deactivated by the dealer admin.
  * 
  * This is distinct from:
  * - DealerPendingPage (org has never been approved)
  * - DealerSuspendedPage (entire org is suspended)
  */
 export function DealerMemberInactivePage() {
   const navigate = useNavigate();
   
   const handleSignOut = async () => {
     await supabase.auth.signOut();
     navigate('/dealer/login');
   };
   
   return (
     <div className="min-h-screen flex items-center justify-center bg-background p-4">
       <Card className="max-w-md w-full">
         <CardHeader className="text-center pb-2">
           <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-muted flex items-center justify-center">
             <UserX className="h-8 w-8 text-muted-foreground" />
           </div>
           <CardTitle className="text-2xl">Account Deactivated</CardTitle>
           <CardDescription className="text-base">
             Your team membership has been deactivated
           </CardDescription>
         </CardHeader>
         <CardContent className="space-y-4">
           <p className="text-sm text-muted-foreground text-center">
             Your access to the Dealer Portal has been deactivated by your dealership administrator. If you believe this is an error, please contact your manager.
           </p>
           
           <div className="bg-muted/50 rounded-lg p-4 text-sm">
             <p className="font-medium mb-2">Possible reasons:</p>
             <ul className="list-disc list-inside space-y-1 text-muted-foreground">
               <li>Role change or team restructuring</li>
               <li>Employment status update</li>
               <li>Temporary access removal</li>
             </ul>
           </div>
           
           <div className="flex flex-col gap-3 pt-4">
             <Button asChild variant="ghost" className="w-full">
               <Link to="/">
                 <Home className="h-4 w-4 mr-2" />
                 Go to Homepage
               </Link>
             </Button>
             
             <Button variant="ghost" onClick={handleSignOut} className="w-full">
               <LogOut className="h-4 w-4 mr-2" />
               Sign Out
             </Button>
           </div>
           
           <div className="flex items-center justify-center gap-2 pt-4 text-xs text-muted-foreground">
             <Mail className="h-3 w-3" />
             <span>Need help? <a href="mailto:support@geargossip.com" className="underline hover:text-primary">Contact Support</a></span>
           </div>
         </CardContent>
       </Card>
     </div>
   );
 }